<template>
  <div class="grid gap-1 p-px bg-gray-100 border border-gray-100 rounded-md sm:grid-flow-col">
    <label v-for="option in options" :key="option.value"
      class="flex flex-col items-center justify-center flex-grow h-10 px-4 py-2 text-sm font-medium leading-tight text-center transition duration-200 rounded cursor-pointer hover:bg-gray-50" 
      :class="{ 'bg-white shadow hover:bg-white': isChecked(option.value) }">
      <input class="hidden" type="radio" :value="option.value" :name="name" :checked="isChecked(option.value)" @change="updateInput"> 
      <div>{{ option.label }}</div>
      <div class="text-xs font-normal text-gray-500">{{ option.tooltip }}</div>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'RadioGroup',

    props: ['options', 'value', 'name', 'tooltip'],

    methods: {
      isChecked (value) {
        return value == this.value
      },

      updateInput(e) {
        this.$emit('input', e.target.value)
      }
    }
  }
</script>